import React, { memo, useRef, useState, useMemo } from 'react';
import Search from '@/pages/intelligence/components/SearchRecent/components/Search';
import { RecordItemType } from '@/pages/intelligence/components/SearchRecent/type';
import { Modal, Button } from 'tea-component';
import { useDebounceEffect } from 'ahooks';
import { addSeachRecord, delSeachRecord, seachRecordList } from '@/pages/intelligence/services/common';
import { buriedPointSearch } from '@/pages/home/utils/buriedPoint';
import './index.scss';
import { useSelector, getLocale } from 'umi';
// import { LANGUAGE_EN } from '@intelligence/_config/config';

interface CommonGamesSearchProps {
  /** 页面的参数 */
  fetchParams: any;
  /** 表格接口：点击后重新请求表格接口的接口 */
  getTableResultList?: Function;
  /** 接口用的搜索类型--每个页面都有自己的搜索类型;新风格一般用v2开头 */
  searchType: string;
  /** 搜索打点信息 */
  pageLogInfo: { pageId: string; typeId: string };
  // 是否为前端搜索
  isFrontEndSearch?: boolean;
  // 搜索是否高亮关键字,目前此功能未支持
  hightLinghtKeyWord?: boolean;
  placeholder?: React.ReactNode;
  defaultImg?: SVGAElement;
  // 是否清除输入的内容
  initSearchInput?: boolean | string;
  // 清除搜索操作函数
  handleClear: Function;
  useSearchRecentFun?: any;
  // Streaming页面进行清空操作的，TODO 可优化为initSearchInput
  resetSearchType?: boolean;
  recordNodataList?: any[];
  // 是否为自定义渲染
  isCustomRendering?: boolean;
  // 是否往请求接口自动附加searchKey
  isOuterSearchKey?: boolean;
  // 是否使用新接口，即游戏详情要单独接口调用，且使用unified_ids而不是filter_ids
  isUseNewApi?: boolean;
  // 搜索使用的key，不同的页面使用的不同，默认为search_by_name
  searchKey?: string;
  renderComp?: (item: any, Func: any) => React.JSX.Element;
  // 前端搜索的数据源
  searchDataList?: any[];
}

function SearchRecentWechat(props: CommonGamesSearchProps) {
  const {
    fetchParams,
    getTableResultList,
    handleClear: handleClearProp = () => console.log /** 清除接口 */,
    searchType: searchTypeProp,
    pageLogInfo,
    isFrontEndSearch,
    hightLinghtKeyWord = false,
    initSearchInput,
    placeholder,
    resetSearchType, // 针对特殊情况,不支持根据下拉选择框动态report,扩展一下
    defaultImg,
    isCustomRendering,
    recordNodataList = [],
    renderComp,
    searchDataList,
  } = props;

  const searchType = resetSearchType || `v2-${searchTypeProp || pageLogInfo?.pageId}`;
  const { userInfo } = useSelector((state) => {
    // @ts-ignore
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  // const locale = getLocale();
  // const isEN = locale === LANGUAGE_EN;

  const [loading, setLoading] = useState(false);
  const [recentRecordList, setRecentRecordList] = useState<any[]>([]);
  const [searchResultList, setSearchResultList] = useState<any[]>([]);
  // 搜索请求接口防抖--用最新的那个返回值
  const inputKey = useRef(0);

  const transRecordDataForSearch = (res: any) => {
    const recordList = res?.data || [];
    if (!Array.isArray(recordList) || !recordList?.length) {
      return [];
    }
    const tranksList: RecordItemType[] = recordList.map((item) => ({
      ...item,
      id: item?.metric_id || item?.game_id,
      imgSrc: item?.metric_cover_url || item?.app_cover,
      lineOneStr: item?.metric_name || item?.app_name,
      lineTwoImg: '',
      lineTwoStr: item?.company_name || item?.publisher,
      metric_id: item?.metric_id || item?.game_id,
    }));

    return tranksList;
  };

  useDebounceEffect(
    () => {
      if (userInfo?.userid && searchType) {
        getRecentRecord();
      }
    },
    [userInfo?.userid, resetSearchType, searchType],
    {
      wait: 300,
    },
  );

  // 转换格式,转换成transResList一样的格式
  const changeFormatResList = (list: any[]) => {
    if (!Array.isArray(list) || !list?.length) {
      return [];
    }
    return list.map((item) => ({
      lineOneStrEn: item?.app_name_en || '',
      lineOneStrCn: item?.app_name_cn || '',
      lineTwoImg: '',
      lineTwoStrEn: item?.publisher_en || '',
      lineTwoStrCn: item?.publisher_cn || '',
      id: item?.game_id || item?.id || item?.metric_id,
      imgSrc: item?.app_cover || item?.imgSrc || item?.metric_cover_url,
      lineOneStr: item?.app_name || item?.lineOneStr || item?.metric_name,
      lineTwoStr: item?.publisher || item?.lineTwoStr || item?.company_name,
      metric_id: item?.game_id || item?.id || item?.metric_id,
    }));
  };

  /** 搜索历史记录 */
  const getRecentRecord = async () => {
    setLoading(true);
    const params = {
      type: searchType,
      user_id: userInfo?.userid,
    };
    let result = null;
    try {
      result = await seachRecordList(params);
      /** 对历史记录数据进行处理*/
      const transResList = transRecordDataForSearch(result);
      setRecentRecordList(transResList);
    } catch (err) { }
    setLoading(false);
  };

  /** 获取搜索结果列表--展示在搜索框 */
  const getSearchResultList = async (inputValue: string) => {
    /** 展示状态： Loading \ 数据 \ 空态 */
    // setLoading(true);
    try {
      if (isFrontEndSearch) {
        // 前端搜索：在 searchDataList 中搜索
        if (!searchDataList?.length) {
          setSearchResultList([]);
          setLoading(false);
          return;
        }

        const keyword = inputValue?.toLowerCase()?.trim();

        // 如果没有输入关键词，显示搜索记录
        if (!keyword) {
          setSearchResultList(recentRecordList);
          setLoading(false);
          return;
        }
        // 在 searchDataList 中过滤
        const filteredList = searchDataList?.filter((item: any) => {
          const appName = (item?.app_name || item?.name || '')?.toLowerCase();
          const publisher = (item?.publisher || item?.lineTwoStr || '')?.toLowerCase();
          return appName.includes(keyword) || publisher.includes(keyword);
        });
        const newFormatResList = changeFormatResList(filteredList);
        setSearchResultList(newFormatResList);
        setLoading(false);
      }
    } catch (err: any) {
      if (err && err?.msg === 'canceled') return;
      setLoading(false);
    }
  };

  /** 点击搜索结果对应条目展示在表格上 */
  const clickSearchItem = async (type: 'record' | 'search', cvm: RecordItemType) => {
    /** 添加条目到历史记录 */
    if (type !== 'record') {
      addRecordItem(cvm);
    }
    if (getTableResultList instanceof Function) {
      getTableResultList(cvm?.app_name || cvm?.name || cvm?.lineOneStr);
    }
  };

  /** 输入搜索关键值 */
  const handleChangeInput = (inputValue: string) => {
    setSearchResultList([]);
    inputKey.current = inputKey.current + 1;
    getSearchResultList(inputValue);
    // 添加搜索打点
    if (pageLogInfo?.pageId) {
      buriedPointSearch({ extInfo: pageLogInfo?.pageId, typeId: pageLogInfo?.typeId }, inputValue);
    }
  };

  /** 点X清除 */
  const handleClear = () => {
    /** 重新展示历史记录 */
    getRecentRecord();
    handleClearProp();
  };

  const addRecordItem = (item: RecordItemType) => {
    if (typeof item !== 'object') {
      return;
    }
    const params = {
      ...item,
      user_id: userInfo?.userid,
      type: searchType,
      metric_id: item.id,
      metric_name: item.lineOneStr,
      metric_cover_url: item.imgSrc,
      company_name: item.lineTwoStr,
      city_name: item.lineTwoStr,
      country_abbre: 'noCountry',
    };
    addSeachRecord({ add_message: [params] });
  };

  /** 删除某个历史记录 */
  const deleteRecordItem = async (item: any) => {
    if (typeof item !== 'object') {
      return;
    }
    const params = {
      metric_id: item.metric_id || '',
      user_id: userInfo?.userid,
    };
    let result = null;
    result = await delSeachRecord(params);
    if (result.code === 0) {
      getRecentRecord();
    } else {
      Modal.error({
        message: 'Sorry',
        description: 'Data cannot be deleted !',
        buttons: [<Button type="primary">Got it!</Button>],
        size: 'm',
      });
    }
  };

  // const recentRecordListCur = useMemo(() => {
  //   return recentRecordList?.map((item: any) => {
  //     return {
  //       ...item,
  //       lineOneStr: (isEN && item?.lineOneStrEn) || item?.lineOneStrCn || item?.lineOneStr,
  //       lineTwoStr: (isEN && item?.lineTwoStrEn) || item?.lineOneStrCn || item?.lineTwoStr,
  //     };
  //   });
  // }, [recentRecordList, isEN]);

  return (
    <Search
      loading={loading}
      handleChangeInput={handleChangeInput}
      resetSearchType={resetSearchType}
      recentRecordList={recentRecordList}
      searchResultList={searchResultList}
      initSearchInput={initSearchInput}
      placeholder={placeholder}
      handleClear={handleClear}
      clickSearchItem={clickSearchItem}
      deleteRecordItem={deleteRecordItem}
      getRecentRecord={getRecentRecord}
      hightLinghtKeyWord={hightLinghtKeyWord}
      isCustomRendering={isCustomRendering}
      searchType={searchType}
      defaultImg={defaultImg}
      fetchParams={fetchParams}
      recordNodataList={recordNodataList}
      renderComp={renderComp}
    />
  );
}
export default memo(SearchRecentWechat);
